<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <!-- content-header component -->
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <!-- Basic Alerts start -->

    <div class="row">
      <div class="col-12">
        <div class="row">
          @for (item of menu; track item.id) {
            @if (item.type === "section" && checkPermission(item)) {
              <div
                class="col-12 mb-1 mt-3"
                [ngClass]="{
                  'hide-mobile': !item.aufHandyAnzeigen,
                }">
                <h3>{{ item.title }}</h3>
              </div>
              @for (child of item.children; track child.id) {
                @if (child.type === "collapsible" && checkPermission(child)) {
                  <div
                    class="col-12"
                    [ngClass]="{
                      'hide-mobile': !child.aufHandyAnzeigen,
                    }">
                    <app-home-collapsible [item]="child"></app-home-collapsible>
                  </div>
                }
                @if (child.type === "item" && checkPermission(child)) {
                  <div
                    class="home-card-column"
                    [ngClass]="{
                      'hide-mobile': !child.aufHandyAnzeigen,
                    }">
                    <app-home-card [item]="child"></app-home-card>
                  </div>
                }
              }
            }
            @if (item.type === "collapsible" && checkPermission(item)) {
              <div
                class="col-12"
                [ngClass]="{
                  'hide-mobile': !item.aufHandyAnzeigen,
                }">
                <app-home-collapsible [item]="item"></app-home-collapsible>
              </div>
            }
            @if (item.type === "item" && checkPermission(item)) {
              <div
                class="home-card-column"
                [ngClass]="{
                  'hide-mobile': !item.aufHandyAnzeigen,
                }">
                <app-home-card [item]="item"></app-home-card>
              </div>
            }
          }
        </div>
      </div>
      <!-- Basic Alerts end -->
    </div>
  </div>
</div>
